export enum CustomDataLayerEventType {
    ECOM_ERROR = 'ecom_error',
}

export const enum EcomAdditionalDataLayerEventType {
    ADD_PAYMENT_INFO = 'add_payment_info',
}

export enum EcomDataLayerEventType {
    VIEW_ITEM_LIST = 'view_item_list',
    SELECT_ITEM = 'select_item',
    ADD_TO_CART = 'add_to_cart',
    ADD_SHIPPING_INFO = 'add_shipping_info',
    PURCHASE = 'purchase',
}
